export default "__VITE_ASSET__B0P30wuS__"